import { render, staticRenderFns } from "./ModalAlterarFornecedor.vue?vue&type=template&id=dd20740e&scoped=true"
import script from "./ModalAlterarFornecedor.vue?vue&type=script&lang=js"
export * from "./ModalAlterarFornecedor.vue?vue&type=script&lang=js"
import style0 from "./ModalAlterarFornecedor.vue?vue&type=style&index=0&id=dd20740e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd20740e",
  null
  
)

export default component.exports